// Drag & Drop 2.0 Engine (Option B Mode)
// Alex GM version 1.0

export function getNewDateFromDrag(startTime: Date, deltaY: number, minutesPerPixel = 1): Date {
  const minutesMoved = deltaY * minutesPerPixel;
  const newDate = new Date(startTime);
  newDate.setMinutes(newDate.getMinutes() + minutesMoved);
  return newDate;
}

export function snapToIncrement(date: Date, increment = 15): Date {
  const minutes = date.getMinutes();
  const snapped = Math.round(minutes / increment) * increment;
  const newDate = new Date(date);
  newDate.setMinutes(snapped);
  return newDate;
}

export function determineNewStaff(currentStaffId: string | null, laneStaffId: string | null): string | null {
  // dragging to a different staff lane changes the staff assignment
  if (currentStaffId !== laneStaffId) return laneStaffId;
  return currentStaffId;
}
